import React from 'react';

import { Grid, Section } from '@gogame/components';
import { SidePageV2, FormField, withForm } from '@gogame/form';

import {
  loadEvents,
  loadBusinessPartners,
  loadAffiliates,
  loadTraffics,
  loadApplications,
  loadActivityTypes,
  loadRegistrationCountries,
  loadEventsCountries,
} from 'scenes/Integrations/sources/postbacks/fields';

import Strategies from './Strategies';
import {
  EVENT,
  BUSINESS_PARTNERS,
  TRAFFIC,
  TRAFFIC_TO_AFFILIATES,
  AFFILIATES,
  STRATEGIES,
  IS_ACTIVE,
  DEPENDENCIES,
  APPLICATION,
  INCLUDE_REJECTED_REGS,
  ACTIVITY_TYPE,
  REGISTRATION_COUNTRIES,
  EVENT_COUNTRIES,
} from './constants';
import { postbackSchema } from './schemas';

const IntegrationPostbackForm = withForm({
  enableReinitialize: true,
  validationSchema: postbackSchema,
})(
  ({
    children,
    title,
    subTitle,
    loading,
    onClose,
    onExited,
    open,
    values,
    setFieldValue,
  }) => {
    const trafficToAffiliatesSelected =
      values[TRAFFIC] === TRAFFIC_TO_AFFILIATES;

    React.useEffect(() => {
      if (!trafficToAffiliatesSelected) {
        setFieldValue(AFFILIATES, []);
      }
    }, [trafficToAffiliatesSelected]);

    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        open={open}
        loading={loading}
        size={'lg'}
      >
        <SidePageV2.Title title={title} subTitle={subTitle} />
        <SidePageV2.NewBody>
          <Section title={'General'}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <FormField.Select
                  label={'Event'}
                  name={EVENT}
                  source={loadEvents}
                  lazy={true}
                  required={true}
                  padding={0}
                />
              </Grid>
              <Grid item xs={4}>
                <FormField.Select
                  label={'Application'}
                  name={APPLICATION}
                  source={loadApplications}
                  lazy={true}
                  required={true}
                  padding={0}
                />
              </Grid>
              <Grid item xs={4}>
                <FormField.MultiSelect
                  label={'Business partners'}
                  name={BUSINESS_PARTNERS}
                  source={loadBusinessPartners}
                  helper={'Partner to send traffic to'}
                  lazy={true}
                  required={true}
                  padding={0}
                />
              </Grid>
              <Grid item xs={4}>
                <FormField.MultiSelect
                  label={'Registration countries'}
                  name={REGISTRATION_COUNTRIES}
                  source={loadRegistrationCountries}
                  withAll={true}
                  lazy={true}
                  padding={0}
                />
              </Grid>
              <Grid item xs={4}>
                <FormField.MultiSelect
                  label={'User(Event) countries'}
                  name={EVENT_COUNTRIES}
                  source={loadEventsCountries}
                  withAll={true}
                  lazy={true}
                  padding={0}
                />
              </Grid>
            </Grid>
          </Section>

          <Grid container spacing={3}>
            <Grid item xs={4}>
              <Section title={'Traffic'}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormField.RadioGroup
                      name={TRAFFIC}
                      radioVertical={true}
                      source={loadTraffics}
                      padding={'0'}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField.MultiSelect
                      label={'Select affiliates'}
                      name={AFFILIATES}
                      source={loadAffiliates}
                      depends={DEPENDENCIES[AFFILIATES]}
                      disabled={!trafficToAffiliatesSelected}
                      lazy={true}
                      padding={0}
                    />
                  </Grid>
                </Grid>
              </Section>
            </Grid>
            <Grid item xs={4}>
              <Section title={'Activity type'}>
                <FormField.RadioGroup
                  name={ACTIVITY_TYPE}
                  radioVertical={true}
                  source={loadActivityTypes}
                  padding={'0'}
                />
              </Section>
            </Grid>
            <Grid item xs={4}>
              <Section title={'Regs'}>
                <FormField.Checkbox
                  label={'Include rejected'}
                  name={INCLUDE_REJECTED_REGS}
                  padding={0}
                />
              </Section>
            </Grid>
          </Grid>

          <Section title={'Strategies'}>
            <Grid container spacing={3}>
              <Strategies name={STRATEGIES} />
            </Grid>
          </Section>
          <Section title={'Status'}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <FormField.Checkbox
                  label={'Active'}
                  name={IS_ACTIVE}
                  padding={0}
                />
              </Grid>
            </Grid>
          </Section>
        </SidePageV2.NewBody>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);

export default IntegrationPostbackForm;
